<h1 mat-dialog-title>{{ data.headerText | translate }}</h1>

<mat-dialog-content class="dialog-content">
  <span class="bold">{{ (data.contentText !== null ? data.contentText : 'UI.NoName') | translate }}</span>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button mat-dialog-close [mat-dialog-close]="false">
    <span>{{ 'UI.Cancel' | translate | uppercase }}</span>
  </button>

  <button type="submit" mat-raised-button class="primary-button" [mat-dialog-close]="true">
    <span>{{ 'UI.Delete' | translate | uppercase }}</span>
  </button>
</mat-dialog-actions>
